module.exports = __webpack_public_path__ + "static/pic01-377165d8b070c8d1d9956bd6c1eba1cd.jpg";